import React, { Component } from "react";
import "./LanguageMobile.css";

import { connect } from "react-redux";
import {
  setActiveLanguage,
  getLanguages,
  getActiveLanguage,
  getTranslate,
} from "react-localize-redux";
import { languageUrls } from "../../languageUrls";

import "../../../locale";

class LanguageMobile extends Component {
  state = {
    languages: ["Ka", "En", "Ru"],
    languageToSow: "Ka",
    counter: 0,
    LanguagePosition: -50,
  };

  handleLanguageChange = () => {
    // this.state.counter++
    // if(this.state.counter > 2){
    //    this.state.counter = 0
    // }
    // this.setState({
    //     languageToSow:this.state.languages[this.state.counter]
    // })
    this.setState((prevstate) => {
      if (prevstate.LanguagePosition === -100) {
        return { LanguagePosition: 0 };
      } else {
        return { LanguagePosition: prevstate.LanguagePosition - 50 };
      }
    });
    document.getElementById(
      "languageMobileItems"
    ).style.top = `${this.state.LanguagePosition}px`;

    setTimeout(() => {
      let newSecondParam = "";
      let pathname = window.location.pathname.split("/");
      if (pathname[2]) {
        newSecondParam = languageUrls.filter(
          (item) => item[pathname[1]] === pathname[2]
        )[0];
        console.log(newSecondParam, "newSecondParam");
      }
      pathname[1] = this.props.currentLocale.code;

      if (pathname[1] && pathname[2]) {
        var url = "/" + pathname[1] + "/" + newSecondParam[pathname[1]];
      } else if (pathname[1]) {
        var url = "" + pathname[1];
      }
      window.history.replaceState(null, "", url);
      url = "";
    }, 1);

    // if (lang !== 'ka' && lang !== 'en' && lang !== 'ru') {
    //     localStorage.setItem('currentLanguage', 'ka')
    //     lang = localStorage.getItem('currentLanguage');
    //     this.props.dispatch(setActiveLanguage(lang));
  };

  render() {
    const { locales, currentLocale, onClick } = this.props;
    return (
      <div className="languageMobile" onClick={this.handleLanguageChange}>
        <div className="languageMobileItems" id="languageMobileItems">
          {/* <a href="#" onClick = {this.handleLanguageChange}> {this.state.languageToSow} </a> */}
          {locales.map(({ code, name, flag }, index) => {
            return (
              <a
                onClick={(e) => {
                  onClick(e, code);
                }}
                key={code}
              >
                {/* {this.state.languages[index]} */}

                <img src={currentLocale.flag} />
              </a>
            );
          })}
        </div>
      </div>
    );
  }
}
const mapStateToProps = ({ locale }) => ({
  locales: getLanguages(locale),
  currentLocale: getActiveLanguage(locale),
  translate: getTranslate(locale),
});

const mapDispatchToProps = (dispatch) => ({
  onClick: (e, code) => {
    dispatch(setActiveLanguage(code));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LanguageMobile);



// WEBPACK FOOTER //
// ./src/components/Header/LanguageMobile/LanguageMobile.js